import { gql } from 'apollo-boost';

export interface CareTeamResponse {
  careTeam: {
    doctor?: string;
    clinicNurse?: string;
    cloudNurse?: string;
  };
}

export const CARE_TEAM_QUERY = gql`
  query careTeam {
    careTeam {
      clinicNurse
      cloudNurse
      doctor
    }
  }
`;
